module.exports = __webpack_public_path__ + "media/images/element/engineering-c3d7b6574c424da1a8b49bc988a333fa.svg";